export const MODULE = "planner/drawer";

export const DRAWER_MODE = {
  ENTRY: "entry",
  ORDER: "order",
  EVENT: "event",
};
